import {
  IconAlignBottom,
  IconAlignTop,
  IconAlignMiddle,
} from '@hivebrite/design-system/Icon';

import type {
  HorizontalAlignmentPosition,
  VerticalAlignmentPosition,
} from 'hb-builder/types/settings';

export const HORIZONTAL_ALIGNMENT: Record<
  HorizontalAlignmentPosition,
  HorizontalAlignmentPosition
> = {
  left: 'left',
  center: 'center',
  right: 'right',
};

export const VERTICAL_ALIGNMENT: Record<
  VerticalAlignmentPosition,
  VerticalAlignmentPosition
> = {
  top: 'top',
  middle: 'middle',
  bottom: 'bottom',
};

export const VERTICAL_ALIGNMENT_ICONS = {
  bottom: IconAlignBottom,
  middle: IconAlignMiddle,
  top: IconAlignTop,
};
